import React from 'react';

interface AuthContainerProps {
  children: React.ReactNode;
  title?: string;
  description?: string;
}

export const AuthContainer: React.FC<AuthContainerProps> = ({
  children,
  title,
  description,
}) => {
  return (
    <div className="flex items-center justify-center px-4 py-12 relative z-10">
      <div className="max-w-md w-full">
        {(title || description) && (
          <div className="text-center mb-8">
            {title && (
              <h1 className="mb-2 text-foreground font-bold">{title}</h1>
            )}
            {description && (
              <p className="text-foreground-secondary">{description}</p>
            )}
          </div>
        )}

        <div className="bg-card rounded-xl shadow-xl p-8 border border-card-border">
          {children}
        </div>
      </div>
    </div>
  );
};
